import React from 'react';
import { Modal } from '../../components';

type AcceptSellerOrderModalProps = {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
  updating: boolean;
};

export const AcceptSellerOrderModal: React.FC<AcceptSellerOrderModalProps> = ({
  open,
  onClose,
  onAccept,
  updating,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title="Accept Order"
    primaryAction={{
      label: 'Confirm',
      variant: 'primary',
      disabled: updating,
      loading: updating,
      onClick: onAccept,
    }}
    secondaryActions={!updating ?[
      {
        label: 'Close',
        variant: 'outline',
        disabled: updating,
        loading: updating,
        onClick: onClose,
      },
    ] : []}
  >
    <p>Once you have accepted this order you will be required to complete the order by fulfilling the items.</p>
    <br />
    <p className='text-foreground'> Do you want to accept this order?</p>
  </Modal>
);

